(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["knilot-boucle-property-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('knilot-boucle-picker')) {
    customElements.define('knilot-boucle-picker', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.form = this.closest('form[action*="/cart/add"]');
        if (!this.form) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.radios = Array.from(this.querySelectorAll('[data-bc-color]'));
        this.variantSelect = this.querySelector('[data-bc-variant]');
        this.dialog = this.querySelector('[data-bc-dialog]');
        this.row = this.querySelector('[data-bc-row]');
        this.addEventListener('click', event => this.handleClick(event), { signal, capture: true });
        this.addEventListener('change', event => {
          if (event.target.matches('[data-bc-color]')) {
            event.stopImmediatePropagation();
            this.syncColor();
          } else if (this.variantSelect && event.target === this.variantSelect) {
            event.stopImmediatePropagation();
            this.syncVariant(true);
          }
        }, { signal, capture: true });
        this.form.addEventListener('invalid', event => {
          if (event.target.matches('[data-bc-color]')) {
            event.preventDefault();
            if (!this.dialog.open) this.requireColor();
          }
        }, { signal, capture: true });
        document.addEventListener('click', event => {
          const target = event.target.closest('[data-buy-button="' + this.dataset.productId + '"]');
          if (target && !this.canBuy()) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        }, { signal, capture: true });
        this.form.addEventListener('submit', event => {
          if (!this.canBuy()) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        }, { signal, capture: true });
        this.dialog.addEventListener('close', () => {
          this.pendingChoice = null;
          this.querySelector('[data-bc-open]').focus({preventScroll:true});
          document.body.classList.remove('knilot-bc-dialog-open');
          this.querySelector('[data-bc-open]').setAttribute('aria-expanded', 'false');
        }, { signal });
        this.row.addEventListener('scroll', () => this.updateArrows(), { signal, passive: true });
        this.resizeObserver = new ResizeObserver(() => this.updateArrows());
        this.resizeObserver.observe(this.row);
        this.removeYmq();
        this.ymqObserver = new MutationObserver(() => this.removeYmq());
        this.ymqObserver.observe(this.form, { childList: true, subtree: true });
        if (this.variantSelect) this.syncVariant(false);
        this.syncColor();
        this.updateArrows();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.ymqObserver?.disconnect();
        this.resizeObserver?.disconnect();
        if (this.dialog?.open) this.dialog.close();
        document.body.classList.remove('knilot-bc-dialog-open');
      }

      removeYmq() {
        this.form.querySelectorAll('#ymq-box').forEach(element => element.remove());
        this.querySelectorAll('button').forEach(button => {
          button.type = 'button';
          button.removeAttribute('ymq-add-to-cart-tags');
        });
      }

      updateArrows() {
        this.querySelector('[data-bc-scroll="-1"]').disabled = this.row.scrollLeft <= 2;
        this.querySelector('[data-bc-scroll="1"]').disabled = this.row.scrollLeft + this.row.clientWidth >= this.row.scrollWidth - 2;
      }

      handleClick(event) {
        const button = event.target.closest('button');
        if (!button || !this.contains(button)) {
          if (event.target === this.dialog) {
            const bounds = this.dialog.getBoundingClientRect();
            if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
          }
          return;
        }
        event.preventDefault();
        event.stopImmediatePropagation();
        if (button.hasAttribute('data-bc-open')) this.openDialog();
        else if (button.hasAttribute('data-bc-close')) this.dialog.close();
        else if (button.hasAttribute('data-bc-apply')) {
          if (!this.pendingChoice) return;
          this.pendingChoice.checked = true;
          this.syncColor();
          this.dialog.close();
        }
        else if (button.hasAttribute('data-bc-scroll')) {
          this.row.scrollBy({ left: Number(button.dataset.bcScroll) * Math.max(84, this.row.clientWidth - 84), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        } else if (button.hasAttribute('data-bc-choice')) {
          this.previewChoice(this.radios[Number(button.dataset.bcChoice)]);
        }
      }

      openDialog() {
        const selected = this.radios.find(radio => radio.checked) || this.radios[0];
        this.previewChoice(selected);
        if (!this.dialog.open) this.dialog.showModal();
        document.body.classList.add('knilot-bc-dialog-open');
        this.querySelector('[data-bc-open]').setAttribute('aria-expanded', 'true');
      }

      previewChoice(radio) {
        this.pendingChoice = radio;
        this.preview(radio);
        this.querySelectorAll('[data-bc-choice]').forEach((b,i) => b.setAttribute('aria-pressed',String(this.radios[i] === radio)));
        this.querySelector('[data-bc-dialog-selected]').textContent = radio.value;
        this.querySelector('[data-bc-apply]').textContent = this.dataset.useLabel.replace('__NAME__',radio.value);
      }

      preview(radio) {
        this.querySelector('[data-bc-preview-name]').textContent = radio.value;
        const image = this.querySelector('[data-bc-large]');
        image.src = radio.dataset.image;
        image.alt = radio.dataset.previewAlt;
      }

      syncColor() {
        const selected = this.radios.find(radio => radio.checked);
        if (selected) {
          this.querySelector('[data-bc-selected]').textContent = selected.value;
          this.querySelector('[data-bc-dialog-selected]').textContent = selected.value;
          this.querySelector('[data-bc-status]').textContent = this.dataset.selected + ' ' + selected.value;
          this.querySelector('[data-bc-error]').hidden = true;
          this.preview(selected);
          const item = selected.closest('.knilot-bc-picker__item');
          const left = item.offsetLeft - this.row.offsetLeft;
          if (left < this.row.scrollLeft || left + item.offsetWidth > this.row.scrollLeft + this.row.clientWidth) this.row.scrollLeft = left;
        }
        this.querySelectorAll('[data-bc-choice]').forEach((button, index) => button.setAttribute('aria-pressed', String(this.radios[index].checked)));
        this.updatePaymentButton();
        this.updateArrows();
      }

      updatePaymentButton() {
        const dynamic = this.form.querySelector('[data-dynamic-button]');
        const variantAvailable = !this.variantSelect || this.variantSelect.selectedOptions[0]?.dataset.available === 'true';
        if (dynamic) dynamic.hidden = !this.radios.some(radio => radio.checked) || !variantAvailable;
      }

      syncVariant(updateUrl) {
        if (!this.variantSelect) return;
        const option = this.variantSelect.selectedOptions[0];
        const input = this.form.querySelector('[data-bstr-variant-input="' + this.dataset.productId + '"]');
        const price = this.querySelector('template[data-bc-price="' + option.value + '"]');
        if (!input || !price) return;
        input.value = option.value;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        document.querySelectorAll('[data-product-price="' + this.dataset.productId + '"]').forEach(element => {
          const holder = element.closest('.product__price--holder');
          if (holder) holder.replaceChildren(price.content.cloneNode(true));
        });
        const quantity = this.form.querySelector('[data-qty-input]');
        if (quantity) {
          if (option.dataset.max !== '') quantity.max = option.dataset.max;
          else quantity.removeAttribute('max');
        }
        document.querySelectorAll('[data-buy-button="' + this.dataset.productId + '"]').forEach(button => {
          button.disabled = option.dataset.available !== 'true';
          const text = button.querySelector('[data-button-text]');
          if (text) text.textContent = button.disabled ? this.dataset.soldOut : button.dataset.originalText;
        });
        this.updatePaymentButton();
        if (updateUrl) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', option.value);
          window.history.replaceState({}, '', url);
        }
      }

      requireColor() {
        const error = this.querySelector('[data-bc-error]');
        error.textContent = this.dataset.required;
        error.hidden = false;
        this.openDialog();
      }

      canBuy() {
        if (!this.radios.some(radio => radio.checked)) {
          this.requireColor();
          return false;
        }
        if (this.variantSelect && this.variantSelect.selectedOptions[0]?.dataset.available !== 'true') {
          const error = this.querySelector('[data-bc-error]');
          error.textContent = this.dataset.unavailable;
          error.hidden = false;
          return false;
        }
        return this.form.reportValidity();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["knilot-embroidery-preview"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('knilot-embroidery-preview')) {
    customElements.define('knilot-embroidery-preview', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.form = this.closest('form[action*="/cart/add"]');
        if (!this.form) return;
        this.paletteHost = this.form.querySelector('knilot-option-palettes[data-product-id="' + this.dataset.productId + '"]');
        this.personalization = this.form.querySelector('knilot-personalization-fields[data-product-id="' + this.dataset.productId + '"]');
        this.velvetGroup = this.form.querySelector('[data-kp-group="velvet48"]');
        this.threadGroup = this.form.querySelector('[data-kp-group="thread21"]');
        if (!this.paletteHost || !this.personalization || !this.velvetGroup || !this.threadGroup) return;

        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.dialog = this.querySelector('[data-ep-dialog]');
        this.launcher = this.querySelector('[data-ep-launcher]');
        this.openButton = this.launcher.querySelector('[data-ep-open]');
        this.error = this.launcher.querySelector('[data-ep-error]');
        this.preview = this.querySelector('[data-ep-preview-text]');
        this.velvetName = this.querySelector('[data-ep-velvet-name]');
        this.snapshotFile = this.querySelector('[data-ep-snapshot-file]');
        this.snapshotLink = this.launcher.querySelector('[data-ep-snapshot-link]');
        this.snapshotStatus = this.launcher.querySelector('[data-ep-snapshot-status]');
        this.form.dataset.knilotEpSnapshot = this.dataset.profile === 'mickey' ? 'mickey-no-piping-v2' : 'personalizer-v2';
        this.variants = JSON.parse(this.querySelector('[data-ep-variants]').textContent);
        this.designCanvas = this.querySelector('[data-ep-design-canvas]');
        this.form.enctype = 'multipart/form-data';
        this.bonePhotoMode = this.dataset.productId === '7771672248496';
        this.mickeyPhotoMode = this.dataset.productId === '7979688624304';
        this.shapedPhotoMode = this.bonePhotoMode || this.mickeyPhotoMode;
        this.pipingEnabled = this.bonePhotoMode;
        this.photoMode = this.dataset.productId === '7776990134448' || this.shapedPhotoMode;
        if (this.photoMode) {
          this.launcherSnapshotObserver = new MutationObserver(() => this.syncLauncherSummary());
          this.launcherSnapshotObserver.observe(this.snapshotFile, { attributes: true, attributeFilter: ['disabled'] });
          this.photoFabrics = new Map();
          this.photoRevision = 0;
          this.photoSetup = import(this.dataset.photoRenderer).then(async module => {
            this.photoAPI = module;
            this.photoRenderer = this.mickeyPhotoMode ? new module.MickeyPhotoRenderer(this.dataset.photoMickey) : this.bonePhotoMode ? new module.DogBonePhotoRenderer(this.dataset.photoBone) : new module.CushionPhotoRenderer({ square: this.dataset.photoSquare, lumbar: this.dataset.photoLumbar });
            await this.photoRenderer.load();
          });
          this.photoSetup.catch(() => {});
        }

        const personalizationSlot = this.querySelector('[data-ep-personalization-slot]');
        personalizationSlot.append(this.personalization);
        this.nameInput = this.querySelector('[data-knilot-pf-control]');
        this.fontInputs = Array.from(this.querySelectorAll('[data-ep-font]'));
        this.sections = Array.from(this.querySelectorAll('[data-ep-section]'));

        this.buildPalette('velvet48', this.velvetGroup);
        this.buildPalette('thread21', this.threadGroup);
        if (this.shapedPhotoMode) { if (this.pipingEnabled) this.buildPipingPalette(); const help = this.personalization.querySelector('.knilot-pf__help'); if (help) help.textContent = this.dataset.nameHelp; }
        this.paletteHost.insertAdjacentElement('afterend', this.launcher);
        document.body.classList.add('knilot-ep-personalizer-ready');
        this.paletteHost.dataset.personalizerReady = 'true';

        this.openButton.addEventListener('click', () => this.openPersonalizer(this.firstMissingSection()), { signal });
        this.querySelectorAll('[data-ep-close]').forEach(button => button.addEventListener('click', () => {
          if (this.shapedPhotoMode && button.classList.contains('knilot-ep__save') && this.firstMissingSection()) {
            const missing = this.firstMissingSection();
            this.openPersonalizer(missing);
            if (missing === 'name') this.nameInput.reportValidity();
            return;
          }
          this.closePersonalizer();
          if (button.classList.contains('knilot-ep__save') && !this.firstMissingSection()) {
            this.prepareSnapshot().catch(() => this.showSnapshotError());
          }
        }, { signal }));
        document.addEventListener('click', event => {
          const target = event.target.closest('[data-buy-button="' + this.dataset.productId + '"]');
          if (target) this.guardSnapshot(event, target);
        }, { signal, capture: true });
        this.form.addEventListener('submit', event => this.guardSnapshot(event, event.submitter), { signal, capture: true });
        this.form.addEventListener('change', () => requestAnimationFrame(() => this.syncAll()), { signal });
        this.variantObserver = new MutationObserver(() => this.syncAll());
        const variantInput = this.form.querySelector('[name="id"]');
        if (variantInput) this.variantObserver.observe(variantInput, { attributes: true, attributeFilter: ['value'] });
        this.dialog.addEventListener('close', () => {
          document.body.classList.remove('knilot-ep-dialog-open');
          this.openButton.setAttribute('aria-expanded', 'false');
        }, { signal });
        this.sections.forEach(section => section.addEventListener('toggle', () => {
          if (!section.open) return;
          this.sections.forEach(other => { if (other !== section) other.open = false; });
        }, { signal }));
        if (this.nameInput) this.nameInput.addEventListener('input', () => this.syncAll(), { signal });
        this.addEventListener('change', event => {
          if (event.target.matches('[data-ep-font]')) {
            this.syncFont(event.target);
            this.syncAll();
          }
        }, { signal });
        this.form.addEventListener('knilot:palette-change', event => {
          if (event.detail?.palette === 'thread21') this.syncThread(event.detail.color);
          if (event.detail?.palette === 'velvet48') this.syncVelvet(event.detail.image, event.detail.value);
          this.syncAll();
        }, { signal });
        this.form.addEventListener('knilot:open-personalizer', event => {
          this.openPersonalizer(event.detail?.section, event.detail?.message, event.detail?.focusId);
        }, { signal });
        this.form.addEventListener('invalid', event => {
          if (!event.target.matches('[data-knilot-pf-control],[data-ep-font],[data-ep-piping]')) return;
          event.preventDefault();
          const section = event.target.matches('[data-ep-font]') ? 'font' : event.target.matches('[data-ep-piping]') ? 'piping' : 'name';
          this.openPersonalizer(section, event.target.validationMessage, event.target.id);
        }, { signal, capture: true });

        this.syncName();
        this.syncThread(this.threadGroup.querySelector('[data-kp-choice]:checked')?.dataset.color);
        const selectedVelvet = this.velvetGroup.querySelector('[data-kp-choice]:checked');
        if (selectedVelvet) this.syncVelvet(selectedVelvet.dataset.image, selectedVelvet.value);
        this.syncFont(this.querySelector('[data-ep-font]:checked'));
        this.syncAll();
      }

      disconnectedCallback() {
        this.invalidateSnapshot();
        if (this.form) delete this.form.dataset.knilotEpSnapshot;
        this.controller?.abort();
        this.variantObserver?.disconnect();
        this.launcherSnapshotObserver?.disconnect();
        if (this.paletteHost) delete this.paletteHost.dataset.personalizerReady;
        this.controller = null;
        if (this.dialog?.open) this.dialog.close();
        this.launcher?.remove();
        document.body.classList.remove('knilot-ep-dialog-open', 'knilot-ep-personalizer-ready');
      }

      buildPalette(key, group) {
        const grid = this.querySelector('[data-ep-palette-grid="' + key + '"]');
        if (!grid) return;
        Array.from(group.querySelectorAll('[data-kp-choice]')).forEach(input => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'knilot-ep__palette-choice';
          button.dataset.epPaletteChoice = key;
          button.dataset.epValue = input.value;
          button.setAttribute('aria-pressed', String(input.checked));
          const originalLabel = group.querySelector('label[for="' + CSS.escape(input.id) + '"]');
          const originalImage = originalLabel?.querySelector('img');
          if (originalImage) {
            const image = originalImage.cloneNode();
            image.alt = '';
            image.width = 58;
            image.height = 58;
            button.append(image);
          } else {
            const swatch = document.createElement('span');
            swatch.className = 'knilot-ep__palette-solid';
            swatch.style.setProperty('--knilot-ep-choice-color', input.dataset.color);
            swatch.setAttribute('aria-hidden', 'true');
            button.append(swatch);
          }
          const name = document.createElement('span');
          name.textContent = input.value;
          button.append(name);
          button.addEventListener('click', () => {
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
            this.syncAll();
          }, { signal: this.controller.signal });
          grid.append(button);
        });
      }

      buildPipingPalette() {
        this.pipingGroup = this.querySelector('[data-ep-piping-controls]');
        this.velvetGroup.querySelectorAll('[data-kp-choice]').forEach((original, index) => {
          const input = original.cloneNode(false);
          input.id = original.id + '-piping-' + index;
          input.name = 'properties[' + this.dataset.pipingProperty + ']';
          input.checked = false; input.defaultChecked = false;
          input.dataset.epPiping = '';
          const label = this.velvetGroup.querySelector('label[for="' + CSS.escape(original.id) + '"]')?.cloneNode(true);
          if (label) label.htmlFor = input.id;
          this.pipingGroup.append(input);
          if (label) this.pipingGroup.append(label);
        });
        this.buildPalette('piping', this.pipingGroup);
      }

      firstMissingSection() {
        if (!this.velvetGroup.querySelector('[data-kp-choice]:checked')) return 'velvet48';
        if (this.pipingEnabled && !this.pipingGroup.querySelector('[data-kp-choice]:checked')) return 'piping';
        if (this.nameInput && (!this.nameInput.value.trim() || !this.nameInput.validity.valid || (this.nameInput.maxLength >= 0 && this.nameInput.value.length > this.nameInput.maxLength) || (this.nameInput.minLength > 0 && this.nameInput.value.length < this.nameInput.minLength))) return 'name';
        if (!this.threadGroup.querySelector('[data-kp-choice]:checked')) return 'thread21';
        if (!this.querySelector('[data-ep-font]:checked')) return 'font';
        return null;
      }

      openPersonalizer(section, message, focusId) {
        if (this.applyPhotoOpeningDefaults()) section = 'name';
        const targetSection = this.sections.find(item => item.dataset.epSection === section);
        if (targetSection) targetSection.open = true;
        if (message) {
          this.error.textContent = message;
          this.error.hidden = false;
        } else {
          this.error.hidden = true;
        }
        if (!this.dialog.open) this.dialog.showModal();
        document.body.classList.add('knilot-ep-dialog-open');
        this.openButton.setAttribute('aria-expanded', 'true');
        requestAnimationFrame(() => {
          const focusTarget = focusId ? this.querySelector('#' + CSS.escape(focusId)) : targetSection?.querySelector('summary');
          focusTarget?.focus({ preventScroll: true });
        });
      }

      closePersonalizer() {
        if (this.dialog.open) this.dialog.close();
      }

      applyPhotoOpeningDefaults() {
        if (!this.photoMode || this.photoOpeningDefaultsApplied) return false;
        this.photoOpeningDefaultsApplied = true;
        const selectedVelvet = this.velvetGroup.querySelector('[data-kp-choice]:checked');
        const selectedThread = this.threadGroup.querySelector('[data-kp-choice]:checked');
        const selectedFont = this.querySelector('[data-ep-font]:checked');
        const pristine = this.nameInput && !this.nameInput.value.trim() && !selectedVelvet && (!selectedThread || selectedThread.defaultChecked) && (!selectedFont || selectedFont.defaultChecked) && this.snapshotFile.disabled && (!this.pipingEnabled || !this.pipingGroup.querySelector('[data-kp-choice]:checked'));
        if (!pristine) return false;
        const velvet = Array.from(this.velvetGroup.querySelectorAll('[data-kp-choice]')).find(input => input.value === this.dataset.openingVelvet);
        const thread = Array.from(this.threadGroup.querySelectorAll('[data-kp-choice]')).find(input => input.value === this.dataset.openingThread);
        const font = this.fontInputs.find(input => input.dataset.photoFont === this.dataset.openingFont);
        if (!velvet || !thread || !font) return false;
        const defaults = [velvet, thread, font];
        if (this.pipingEnabled) { const piping = Array.from(this.pipingGroup.querySelectorAll('[data-kp-choice]')).find(input => input.value === this.dataset.openingPiping); if (!piping) return false; defaults.push(piping); }
        defaults.forEach(input => {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
        this.nameInput.value = this.dataset.openingName;
        this.nameInput.dispatchEvent(new Event('input', { bubbles: true }));
        this.photoOpeningExample = true;
        this.syncAll();
        return true;
      }

      syncAll() {
        if (this.snapshotSignature && this.snapshotSignature !== JSON.stringify(this.snapshotState())) this.invalidateSnapshot();
        this.syncName();
        const velvet = this.velvetGroup.querySelector('[data-kp-choice]:checked');
        const thread = this.threadGroup.querySelector('[data-kp-choice]:checked');
        const font = this.querySelector('[data-ep-font]:checked');
        const name = this.nameInput?.value.trim();
        const openingExample = this.querySelector('[data-ep-opening-example]');
        if (openingExample) openingExample.hidden = !this.photoOpeningExample || name !== this.dataset.openingName;
        const notSelected = this.dataset.notSelected;
        const values = [velvet?.value || notSelected, name || notSelected, thread?.value || notSelected, font?.value || notSelected];
        const piping = this.pipingEnabled ? this.pipingGroup.querySelector('[data-kp-choice]:checked') : null;
        if (this.pipingEnabled) { values.push(piping?.value || notSelected); this.querySelector('[data-ep-section-value="piping"]').textContent = piping?.value || notSelected; }
        this.querySelector('[data-ep-section-value="velvet48"]').textContent = velvet?.value || notSelected;
        this.querySelector('[data-ep-section-value="name"]').textContent = name || notSelected;
        this.querySelector('[data-ep-section-value="thread21"]').textContent = thread?.value || notSelected;
        this.querySelector('[data-ep-section-value="font"]').textContent = font?.value || notSelected;
        this.syncLauncherSummary(values);
        this.querySelector('[data-ep-dialog-summary]').textContent = values.join(' · ');
        this.querySelectorAll('[data-ep-palette-choice]').forEach(button => {
          const selected = button.dataset.epPaletteChoice === 'velvet48' ? velvet : button.dataset.epPaletteChoice === 'piping' ? piping : thread;
          button.setAttribute('aria-pressed', String(button.dataset.epValue === selected?.value));
        });
        if (!this.firstMissingSection()) this.error.hidden = true;
        this.refreshIllustration();
      }

      syncLauncherSummary(values) {
        const summary = this.launcher.querySelector('[data-ep-launcher-summary]');
        if (!this.photoMode) {
          summary.textContent = this.dataset.summaryPrefix + ': ' + values.join(' · ');
          return;
        }
        const state = this.snapshotState();
        const saved = Boolean(this.snapshotSignature && this.snapshotSignature === JSON.stringify(state) && this.snapshotFile && !this.snapshotFile.disabled && this.snapshotFile.files.length === 1);
        this.openButton.querySelector('[data-ep-launch-label]').textContent = saved ? this.dataset.launchEditLabel : this.dataset.launchPersonalizeLabel;
        this.launcher.querySelector('[data-ep-launch-support]').hidden = saved;
        summary.hidden = !saved;
        summary.replaceChildren();
        if (!saved) return;
        const lines = [
          this.dataset.launchSavedLabel,
          this.dataset.launchNameLabel + ': ' + state.name.trim() + ' · ' + this.dataset.launchVelvetLabel + ': ' + state.velvet,
          this.dataset.launchThreadLabel + ': ' + state.thread + ' · ' + this.dataset.launchFontLabel + ': ' + state.font
        ];
        if (this.pipingEnabled) lines.push(this.dataset.pipingLabel + ': ' + state.piping);
        lines.forEach((text, index) => {
          const line = document.createElement('span');
          line.className = 'knilot-ep__summary-line' + (index === 0 ? ' knilot-ep__saved-status' : '');
          line.textContent = text;
          summary.append(line);
        });
      }

      syncName() {
        if (!this.preview) return;
        const value = this.nameInput?.value.trim();
        this.preview.textContent = value || this.dataset.previewPlaceholder;
        this.preview.dataset.length = String((value || this.dataset.previewPlaceholder).length);
      }

      snapshotState() {
        const velvet = this.velvetGroup.querySelector('[data-kp-choice]:checked');
        const thread = this.threadGroup.querySelector('[data-kp-choice]:checked');
        const font = this.querySelector('[data-ep-font]:checked');
        return {
          version: this.dataset.productId === '7776990134448' ? 'cushion-photo-v1' : this.dataset.profile === 'mickey' ? 'mickey-no-piping-v2' : 'personalizer-v2', product: this.dataset.productId,
          profile: this.dataset.profile,
          variant: this.form.querySelector('[name="id"]')?.value,
          variantTitle: this.variants.find(item => item.id === this.form.querySelector('[name="id"]')?.value)?.title || '',
          velvet: velvet?.value, image: velvet?.dataset.image,
          thread: thread?.value, threadColor: thread?.dataset.color,
          name: this.nameInput?.value, font: font?.value,
          family: font?.dataset.fontFamily, weight: font?.dataset.fontWeight,
          ...(this.pipingEnabled ? { piping: this.pipingGroup.querySelector('[data-kp-choice]:checked')?.value, pipingImage: this.pipingGroup.querySelector('[data-kp-choice]:checked')?.dataset.image } : {})
        };
      }

      invalidateSnapshot() {
        this.snapshotSignature = null;
        if (this.shapedPhotoMode) delete this.dataset.photoSaved;
        if (this.snapshotFile) {
          this.snapshotFile.value = '';
          this.snapshotFile.disabled = true;
        }
        if (this.snapshotUrl) URL.revokeObjectURL(this.snapshotUrl);
        this.snapshotUrl = null;
        if (this.snapshotLink) {
          this.snapshotLink.hidden = true;
          this.snapshotLink.removeAttribute('href');
        }
      }

      showSnapshotError() {
        this.error.textContent = this.dataset.snapshotError;
        this.error.hidden = false;
      }

      async guardSnapshot(event, target) {
        const state = JSON.stringify(this.snapshotState());
        if (this.snapshotSignature === state && this.snapshotFile.files.length === 1) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (this.firstMissingSection()) {
          this.openPersonalizer(this.firstMissingSection());
          return;
        }
        if (!this.form.reportValidity() || this.snapshotPurchasePending) return;
        this.snapshotPurchasePending = true;
        try {
          await this.prepareSnapshot();
          if (state !== JSON.stringify(this.snapshotState()) || !this.isConnected) throw new Error('Selection changed');
          if (event.type === 'click') target.click();
          else this.form.requestSubmit(target || undefined);
        } catch {
          this.showSnapshotError();
        } finally {
          this.snapshotPurchasePending = false;
        }
      }

      async prepareSnapshot() {
        if (this.photoMode) return this.prepareCushionSnapshot();
        if (this.firstMissingSection()) throw new Error('Incomplete personalization');
        const state = this.snapshotState();
        const signature = JSON.stringify(state);
        if (this.snapshotSignature === signature && this.snapshotFile.files.length === 1) return;
        if (this.snapshotPreparing) {
          await this.snapshotPreparing;
          if (this.snapshotSignature === signature) return;
        }
        this.invalidateSnapshot();
        this.error.hidden = true;
        this.snapshotStatus.textContent = this.dataset.snapshotBusy;
        this.snapshotPreparing = (async () => {
          const font = await Promise.race([
            window.knilotEmbroideryFonts?.get(state.family),
            new Promise((_, reject) => setTimeout(() => reject(new Error('Font timeout')), 12000))
          ]);
          if (!font || font.status !== 'loaded') throw new Error('Font not ready');
          const image = await new Promise((resolve, reject) => {
            const swatch = new Image();
            const timer = setTimeout(() => reject(new Error('Swatch timeout')), 12000);
            swatch.crossOrigin = 'anonymous';
            swatch.onload = () => { clearTimeout(timer); resolve(swatch); };
            swatch.onerror = () => { clearTimeout(timer); reject(new Error('Swatch unavailable')); };
            swatch.src = state.image;
          });
          const canvas = this.drawSnapshot(state, image);
          const blob = await new Promise((resolve, reject) => canvas.toBlob(value => value ? resolve(value) : reject(new Error('Image export failed')), 'image/png'));
          if (blob.size > 4000000 || signature !== JSON.stringify(this.snapshotState()) || !this.isConnected) throw new Error('Invalid snapshot');
          const transfer = new DataTransfer();
          transfer.items.add(new File([blob], 'knilot-design-' + crypto.randomUUID() + '.png', { type: 'image/png' }));
          this.snapshotFile.files = transfer.files;
          this.snapshotFile.disabled = false;
          this.snapshotSignature = signature;
          this.snapshotUrl = URL.createObjectURL(blob);
          this.snapshotLink.href = this.snapshotUrl;
          this.snapshotLink.hidden = false;
        })();
        try {
          await this.snapshotPreparing;
        } catch (error) {
          this.invalidateSnapshot();
          throw error;
        } finally {
          this.snapshotPreparing = null;
          this.snapshotStatus.textContent = '';
        }
      }

      drawSnapshot(state, image) {
        const canvas = document.createElement('canvas');
        canvas.width = 1000;
        canvas.height = 1330;
        const ctx = canvas.getContext('2d');
        ctx.fillStyle = '#fffdf8';
        ctx.fillRect(0, 0, 1000, 1330);
        ctx.fillStyle = '#29251e';
        ctx.font = '600 28px sans-serif';
        ctx.textAlign = 'center';
        ctx.fillText(this.dataset.snapshotTitle, 500, 48, 910);
        ctx.save();
        ctx.translate(0, 60);
        if (state.profile !== 'mickey') {
          this.drawIllustration(ctx, state, image);
        } else {
        const shape = (x, y, size, lowerRadius) => {
          ctx.save();
          ctx.beginPath();
          ctx.roundRect(x, y, size, size, [size / 2, size / 2, lowerRadius * size, lowerRadius * size]);
          ctx.shadowColor = '#0003';
          ctx.shadowBlur = 18;
          ctx.shadowOffsetY = 7;
          ctx.fillStyle = '#d8d4ca';
          ctx.fill();
          ctx.shadowColor = 'transparent';
          ctx.clip();
          const width = size * 1.7;
          const height = width * image.naturalHeight / image.naturalWidth;
          ctx.drawImage(image, x + (size - width) / 2, y + (size - height) / 2, width, height);
          ctx.restore();
        };
        shape(110, 80, 340, .5);
        shape(550, 80, 340, .5);
        shape(180, 250, 640, .46);
        ctx.fillStyle = state.threadColor;
        ctx.font = state.weight + ' 90px "' + state.family + '"';
        ctx.textBaseline = 'middle';
        ctx.shadowColor = '#0005';
        ctx.shadowBlur = 2;
        ctx.shadowOffsetY = 1;
        const rows = [];
        let row = '';
        for (const letter of state.name.trim()) {
          if (row && ctx.measureText(row + letter).width > 520) { rows.push(row); row = ''; }
          row += letter;
        }
        rows.push(row);
        rows.forEach((text, index) => ctx.fillText(text, 500, 600 + (index - (rows.length - 1) / 2) * 90, 520));
        }
        ctx.restore();
        ctx.textAlign = 'left';
        ctx.textBaseline = 'alphabetic';
        ctx.fillStyle = '#29251e';
        const labels = [
          this.querySelector('[data-ep-section="name"] summary span')?.textContent || 'Name',
          this.querySelector('[data-ep-section="velvet48"] summary span')?.textContent || 'Velvet',
          this.querySelector('[data-ep-section="thread21"] summary span')?.textContent || 'Thread',
          this.querySelector('[data-ep-section="font"] summary span')?.textContent || 'Font'
        ];
        const values = [state.name, state.velvet, state.thread, state.font];
        values.forEach((value, index) => {
          ctx.font = '600 23px sans-serif';
          ctx.fillText(labels[index] + ':', 65, 1040 + index * 43, 250);
          ctx.font = '23px sans-serif';
          ctx.fillText(value, 330, 1040 + index * 43, 605);
        });
        ctx.fillStyle = '#625a4b';
        ctx.font = '18px sans-serif';
        ctx.fillText(this.dataset.snapshotNote, 65, 1230, 870);
        ctx.font = '15px sans-serif';
        ctx.fillText(this.dataset.productTitle, 65, 1005, 870);
        ctx.fillText(state.profile + ' · ' + state.version + ' · ' + state.variant, 65, 1300, 870);
        if (state.variantTitle && state.variantTitle !== 'Default Title') ctx.fillText(this.dataset.sizeLabel + ': ' + state.variantTitle, 65, 1265, 870);
        return canvas;
      }

      refreshIllustration() {
        if (this.photoMode) { this.refreshCushionPhoto(); return; }
        if (!this.designCanvas) return;
        const state = this.snapshotState();
        const signature = JSON.stringify(state);
        this.illustrationSignature = signature;
        const paint = image => {
          if (this.illustrationSignature !== signature) return;
          const ctx = this.designCanvas.getContext('2d');
          ctx.clearRect(0, 0, 1000, 1000);
          this.drawIllustration(ctx, state, image);
        };
        if (!state.image || (this.pipingEnabled && !state.pipingImage)) { paint(null); return; }
        if (this.illustrationImage?.src === state.image && this.illustrationImage.complete) { paint(this.illustrationImage); return; }
        const image = new Image();
        image.crossOrigin = 'anonymous';
        image.onload = () => { this.illustrationImage = image; paint(image); };
        image.onerror = () => paint(null);
        image.src = state.image;
      }

      drawIllustration(ctx, state, image) {
        ctx.save();
        const path = new Path2D();
        let box = { x: 100, y: 215, w: 800, h: 570 };
        let textWidth = 560;
        if (state.profile === 'bone') {
          path.moveTo(300, 380);
          path.bezierCurveTo(160, 150, 0, 400, 140, 500);
          path.bezierCurveTo(0, 620, 160, 850, 300, 620);
          path.lineTo(700, 620);
          path.bezierCurveTo(840, 850, 1000, 620, 860, 500);
          path.bezierCurveTo(1000, 400, 840, 150, 700, 380);
          path.closePath();
          box = { x: 60, y: 235, w: 880, h: 530 };
          textWidth = 550;
        } else if (state.profile === 'initial') {
          const dims = (state.variantTitle || '').match(/(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)/i);
          const ratio = dims ? Number(dims[2]) / Number(dims[1]) : 1;
          const w = ratio >= 1 ? 760 : 760 * ratio;
          const h = ratio >= 1 ? 760 / ratio : 760;
          box = { x: (1000 - w) / 2, y: (1000 - h) / 2, w, h };
          path.roundRect(box.x, box.y, w, h, 55);
          textWidth = w * .6;
        } else {
          path.roundRect(box.x, box.y, box.w, box.h, [55,55,75,75]);
        }
        ctx.shadowColor = '#0003'; ctx.shadowBlur = 20; ctx.shadowOffsetY = 10;
        ctx.fillStyle = '#d8d4ca'; ctx.fill(path);
        ctx.shadowColor = 'transparent';
        ctx.save(); ctx.clip(path);
        if (image) {
          const source = Math.min(image.naturalWidth, image.naturalHeight) * .55;
          ctx.drawImage(image, (image.naturalWidth-source)/2, (image.naturalHeight-source)/2, source, source, box.x, box.y, box.w, box.h);
        }
        if (state.profile === 'pouch') {
          ctx.strokeStyle = '#ffffff38'; ctx.lineWidth = 3;
          for (let offset=-600; offset<1500; offset+=110) {
            ctx.beginPath(); ctx.moveTo(offset, box.y); ctx.lineTo(offset+box.h, box.y+box.h); ctx.stroke();
            ctx.beginPath(); ctx.moveTo(offset, box.y); ctx.lineTo(offset-box.h, box.y+box.h); ctx.stroke();
          }
        }
        ctx.restore();
        ctx.strokeStyle = state.profile === 'bone' ? '#f5f0e2' : '#0003'; ctx.lineWidth = state.profile === 'bone' ? 12 : 4; ctx.stroke(path);
        if (state.profile === 'pouch') {
          ctx.strokeStyle = '#c8a354'; ctx.lineWidth = 9;
          ctx.beginPath(); ctx.moveTo(155,270); ctx.lineTo(845,270); ctx.stroke();
          ctx.lineWidth = 7; ctx.beginPath(); ctx.moveTo(840,270); ctx.lineTo(905,335); ctx.stroke();
          ctx.strokeStyle = '#a38965';
          for(let i=0;i<6;i++){ctx.beginPath();ctx.moveTo(905+i*3,335);ctx.lineTo(890+i*7,435);ctx.stroke();}
        }
        const text = state.name?.trim() || this.dataset.previewPlaceholder;
        let fontSize = state.profile === 'initial' ? Math.min(box.h*.48,260) : 95;
        ctx.font = state.weight + ' ' + fontSize + 'px "' + state.family + '"';
        while(ctx.measureText(text).width>textWidth && fontSize>14){fontSize-=2;ctx.font=state.weight+' '+fontSize+'px "'+state.family+'"';}
        ctx.fillStyle = state.threadColor || '#c9252d'; ctx.textAlign='center'; ctx.textBaseline='middle';
        ctx.shadowColor='#0005';ctx.shadowBlur=2;ctx.shadowOffsetY=1;
        ctx.fillText(text, 500, state.profile === 'pouch' ? 540 : 500, textWidth);
        ctx.restore();
      }

      cushionAwait(promise) {
        return new Promise((resolve, reject) => {
          const timer = setTimeout(() => reject(new Error('Preview load timeout')), 12000);
          Promise.resolve(promise).then(value => { clearTimeout(timer); resolve(value); }, error => { clearTimeout(timer); reject(error); });
        });
      }

      async bonePhoto(state, revision) {
        await this.cushionAwait(this.photoSetup);
        if (!state.image || (this.pipingEnabled && !state.pipingImage) || !state.threadColor) throw new Error('Incomplete palettes');
        const swatch = async (image, label) => {
          if (!this.photoFabrics.has(image)) {
            const promise = this.photoAPI.sampleSwatch({ id: image, label, image, patternException: label === 'Green Stripe' });
            this.photoFabrics.set(image, promise); promise.catch(() => this.photoFabrics.delete(image));
          }
          return this.cushionAwait(this.photoFabrics.get(image));
        };
        const [fabric, piping, font] = await Promise.all([swatch(state.image, state.velvet), this.pipingEnabled ? swatch(state.pipingImage, state.piping) : null, this.cushionAwait(window.knilotEmbroideryFonts?.get(state.family))]);
        if (font?.status !== 'loaded' || !this.isConnected || revision !== this.photoRevision || JSON.stringify(state) !== JSON.stringify(this.snapshotState())) throw new Error('Font or choices not ready');
        const selectedFont = this.querySelector('[data-ep-font]:checked');
        const output = this.photoAPI.canvas(1254, 1254);
        const qa = this.photoRenderer.render({ name: state.name || '', fabric, piping, thread: {label: state.thread, color: state.threadColor}, font: {id: selectedFont.dataset.photoFont, label: state.font, family: '"' + state.family + '"', weight: state.weight, ready: true} }, output);
        this.designCanvas.width = output.width; this.designCanvas.height = output.height;
        this.designCanvas.getContext('2d').drawImage(output, 0, 0);
        this.photoVisibleSignature = JSON.stringify(state); this.dataset.photoQa = JSON.stringify({ ...qa, fontReady: true, requestedName: state.name });
        return output;
      }

      async cushionPhoto(state, revision) {
        if (this.shapedPhotoMode) return this.bonePhoto(state, revision);
        await this.cushionAwait(this.photoSetup);
        if (!state.image || !state.threadColor) throw new Error('Incomplete palette');
        const dims = state.variantTitle.match(/(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)/i);
        if (!dims) throw new Error('Unknown cushion size');
        const shortSide = Math.min(Number(dims[1]), Number(dims[2]));
        const longSide = Math.max(Number(dims[1]), Number(dims[2]));
        if (!(shortSide > 0)) throw new Error('Unknown cushion dimensions');
        if (!this.photoFabrics.has(state.image)) {
          const promise = this.photoAPI.sampleSwatch({ id: state.image, label: state.velvet, image: state.image, patternException: state.velvet === 'Green Stripe' });
          this.photoFabrics.set(state.image, promise);
          promise.catch(() => this.photoFabrics.delete(state.image));
        }
        const fabric = await this.cushionAwait(this.photoFabrics.get(state.image));
        const font = await this.cushionAwait(window.knilotEmbroideryFonts?.get(state.family));
        if (!this.isConnected || revision !== this.photoRevision || JSON.stringify(state) !== JSON.stringify(this.snapshotState())) throw new Error('Selection changed');
        const selectedFont = this.querySelector('[data-ep-font]:checked');
        const fontReady = font?.status === 'loaded';
        const renderState = {
          name: fontReady ? state.name || '' : '',
          size: { variant_id: state.variant, size: state.variantTitle, shape: shortSide === longSide ? 'square' : 'lumbar', long_side: longSide, short_side: shortSide },
          fabric,
          thread: { id: state.thread, label: state.thread, color: state.threadColor },
          font: { id: selectedFont.dataset.photoFont, label: state.font, family: '"' + state.family + '"', weight: state.weight, ready: true }
        };
        const output = this.photoAPI.canvas(1254, 1254);
        const qa = this.photoRenderer.render(renderState, output);
        this.designCanvas.width = 1254;
        this.designCanvas.height = 1254;
        this.designCanvas.getContext('2d').drawImage(output, 0, 0);
        this.photoVisibleSignature = JSON.stringify(state);
        this.dataset.photoQa = JSON.stringify({ ...qa, fontReady, requestedName: state.name });
        if (!fontReady) throw new Error('Selected font unavailable');
        return output;
      }

      refreshCushionPhoto() {
        const state = this.snapshotState();
        if (this.shapedPhotoMode) {
          const signature = JSON.stringify(state);
          if (this.photoRequestSignature === signature) return;
          this.photoRequestSignature = signature;
        }
        const revision = ++this.photoRevision;
        const status = this.querySelector('[data-ep-photo-status]');
        this.dataset.photoState = 'loading';
        status.textContent = this.dataset.photoLoading;
        this.designCanvas.getContext('2d').clearRect(0, 0, this.designCanvas.width, this.designCanvas.height);
        if (!state.image || (this.pipingEnabled && !state.pipingImage)) {
          this.dataset.photoState = 'incomplete';
          status.textContent = this.dataset.notSelected;
          return;
        }
        this.cushionPhoto(state, revision).then(() => {
          if (revision !== this.photoRevision) return;
          this.dataset.photoState = 'ready';
          status.textContent = this.dataset.photoReady;
        }).catch(() => {
          if (revision !== this.photoRevision) return;
          if (this.shapedPhotoMode) this.photoRequestSignature = null;
          this.dataset.photoState = 'error';
          status.textContent = this.dataset.photoError;
        });
      }

      async prepareCushionSnapshot() {
        if (this.firstMissingSection() || !this.nameInput?.value.trim() || this.nameInput.value.length > (this.shapedPhotoMode ? 20 : 10)) throw new Error('Incomplete personalization');
        const state = this.snapshotState();
        const signature = JSON.stringify(state);
        if (this.snapshotSignature === signature && this.snapshotFile.files.length === 1) return;
        if (this.snapshotPreparing) {
          await this.snapshotPreparing;
          if (this.snapshotSignature === signature) return;
        }
        this.invalidateSnapshot();
        this.snapshotStatus.textContent = this.dataset.snapshotBusy;
        const revision = ++this.photoRevision;
        this.snapshotPreparing = (async () => {
          const output = await this.cushionPhoto(state, revision);
          const blob = await new Promise((resolve, reject) => output.toBlob(value => value ? resolve(value) : reject(new Error('PNG export failed')), 'image/png'));
          if (blob.size > 4000000 || signature !== JSON.stringify(this.snapshotState()) || revision !== this.photoRevision || !this.isConnected) throw new Error('Selection changed');
          const decoded = await createImageBitmap(blob);
          const check = this.photoAPI.canvas(output.width, output.height);
          check.getContext('2d').drawImage(decoded, 0, 0);
          decoded.close();
          const saved = check.getContext('2d').getImageData(0, 0, output.width, output.height).data;
          const visible = this.designCanvas.getContext('2d').getImageData(0, 0, output.width, output.height).data;
          for (let i = 0; i < saved.length; i++) if (saved[i] !== visible[i]) throw new Error('Saved preview differs');
          if (signature !== JSON.stringify(this.snapshotState()) || revision !== this.photoRevision) throw new Error('Selection changed');
          const transfer = new DataTransfer();
          transfer.items.add(new File([blob], 'knilot-design-' + crypto.randomUUID() + '.png', { type: 'image/png' }));
          this.snapshotFile.files = transfer.files;
          this.snapshotFile.disabled = false;
          this.snapshotSignature = signature;
          this.snapshotUrl = URL.createObjectURL(blob);
          this.snapshotLink.href = this.snapshotUrl;
          this.snapshotLink.hidden = false;
          this.dataset.photoState = 'ready';
          this.querySelector('[data-ep-photo-status]').textContent = this.dataset.photoReady;
          this.dataset.photoSaved = JSON.stringify({ matchesVisible: true, comparison: 'every RGBA byte after PNG encode/decode', bytes: blob.size, signature });
        })();
        try {
          await this.snapshotPreparing;
        } catch (error) {
          this.invalidateSnapshot();
          throw error;
        } finally {
          this.snapshotPreparing = null;
          this.snapshotStatus.textContent = '';
        }
      }

      syncThread(color) {
        if (color) this.style.setProperty('--knilot-ep-thread', color);
      }

      syncVelvet(image, value) {
        if (!image) return;
        const safeImage = image.replace(/["\\]/g, '');
        this.style.setProperty('--knilot-ep-velvet-image', 'url("' + safeImage + '")');
        if (this.velvetName && value) this.velvetName.textContent = value;
      }

      syncFont(choice) {
        if (!choice || !this.preview) return;
        const family = choice.dataset.fontFamily;
        const stack = choice.dataset.fontStack || 'sans-serif';
        const weight = choice.dataset.fontWeight || '400';
        this.preview.style.fontFamily = '"' + family + '",' + stack;
        this.preview.style.fontWeight = weight;
        if (this.photoMode && !choice.dataset.fontUrl) {
          const registry = window.knilotEmbroideryFonts || (window.knilotEmbroideryFonts = new Map());
          registry.set(family, Promise.resolve(null));
          return;
        }
        if (!('FontFace' in window) || !choice.dataset.fontUrl) return;
        const registry = window.knilotEmbroideryFonts || (window.knilotEmbroideryFonts = new Map());
        if (!registry.has(family)) {
          const source = 'url("' + choice.dataset.fontUrl.replace(/"/g, '') + '") format("' + (choice.dataset.fontFormat || 'woff2') + '")';
          const font = new FontFace(family, source, { style: 'normal', weight, display: 'swap' });
          registry.set(family, font.load().then(loaded => {
            document.fonts.add(loaded);
            return loaded;
          }).catch(() => null));
        }
        registry.get(family).then(loaded => {
          if (loaded && choice.checked) {
            this.preview.style.fontFamily = '"' + family + '",' + stack;
            this.refreshIllustration();
          }
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["knilot-option-palette-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('knilot-option-palettes')) {
    customElements.define('knilot-option-palettes', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.form = this.closest('form[action*="/cart/add"]');
        if (!this.form) return;
        this.personalizerProduct = this.dataset.personalizer === 'true';
        this.form.classList.add('knilot-kp-form');
        this.paletteOnly = this.dataset.paletteOnly === 'true';
        this.form.classList.add(this.paletteOnly ? 'knilot-kp-palette-form' : 'knilot-kp-native-form');
        document.body.classList.add('knilot-kp-active');
        if (this.dataset.productId === '7979688624304') document.body.classList.add('knilot-kp-mickey');
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const nativeLengths = this.querySelector('[data-kp-native-lengths]');
        this.nativeLengths = nativeLengths ? JSON.parse(nativeLengths.textContent) : null;
        this.lengthSelect = this.querySelector('[data-kp-length]');
        this.form.addEventListener('formdata', event => {
          if (this.nativeLengths && this.syncNativeLength()) event.formData.set('id', this.form.querySelector('input[name="id"]').value);
        }, { signal });
        this.groups = Array.from(this.querySelectorAll('[data-kp-group]'));
        this.addEventListener('click', event => this.handleClick(event), { signal, capture: true });
        this.addEventListener('keydown', event => {
          if (!event.target.matches('[data-kp-choice]') || ![' ', 'Enter'].includes(event.key)) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          event.target.checked = true;
          const group = event.target.closest('[data-kp-group]');
          this.syncGroup(group);
        }, { signal, capture: true });
        this.addEventListener('change', event => {
          if (event.target === this.lengthSelect) {
            event.stopImmediatePropagation();
            this.updateNativeLength(true);
          } else if (event.target.matches('[data-kp-choice]')) {
            event.stopImmediatePropagation();
            this.syncGroup(event.target.closest('[data-kp-group]'));
          }
        }, { signal, capture: true });
        this.form.addEventListener('invalid', event => {
          if (event.target.matches('[data-kp-choice]')) {
            event.preventDefault();
            this.requireGroup(event.target.closest('[data-kp-group]'));
          }
        }, { signal, capture: true });
        document.addEventListener('click', event => {
          const target = event.target.closest('[data-buy-button="' + this.dataset.productId + '"]');
          if (target && !this.canBuy()) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        }, { signal, capture: true });
        this.form.addEventListener('submit', event => {
          if (!this.canBuy()) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        }, { signal, capture: true });
        this.groups.forEach(group => {
          const dialog = group.querySelector('[data-kp-dialog]');
          const row = group.querySelector('[data-kp-row]');
          dialog.addEventListener('close', () => {
            group.pendingChoice = null;
            group.querySelector('[data-kp-open]').focus({preventScroll:true});
            document.body.classList.remove('knilot-kp-dialog-open');
            group.querySelector('[data-kp-open]').setAttribute('aria-expanded', 'false');
          }, { signal });
          row.addEventListener('scroll', () => this.updateArrows(group), { signal, passive: true });
          const observer = new ResizeObserver(() => this.updateArrows(group));
          observer.observe(row);
          group.kpResizeObserver = observer;
          this.syncGroup(group);
        });
        this.removeYmq();
        this.updateNativeLength(false);
        this.ymqObserver = new MutationObserver(() => this.removeYmq());
        this.ymqObserver.observe(this.form, { childList: true, subtree: true });
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.ymqObserver?.disconnect();
        this.groups?.forEach(group => group.kpResizeObserver?.disconnect());
        this.querySelectorAll('[data-kp-dialog]').forEach(dialog => { if (dialog.open) dialog.close(); });
        this.form?.classList.remove('knilot-kp-form', 'knilot-kp-palette-form', 'knilot-kp-native-form');
        document.body.classList.remove('knilot-kp-dialog-open');
        document.body.classList.remove('knilot-kp-active', 'knilot-kp-mickey');
      }

      removeYmq() {
        if (this.paletteOnly) {
          if (this.querySelector('[data-kp-group="velvet48"]')) this.form.querySelectorAll('#option-box-501tem2').forEach(element => element.remove());
          if (this.querySelector('[data-kp-group="thread21"]')) this.form.querySelectorAll('#option-box-503tem2').forEach(element => element.remove());
          if (this.querySelector('[data-kp-group="linen5"]')) this.form.querySelectorAll('#option-box-505tem2').forEach(element => element.remove());
        } else {
          this.form.querySelectorAll('#ymq-box').forEach(element => element.remove());
        }
        if (this.personalizerProduct && this.dataset.singleVariant === 'true' && this.form.querySelector('knilot-personalization-fields')) {
          this.form.querySelectorAll('#ymq-box').forEach(element => element.remove());
        }
        if (!this.paletteOnly) this.form.querySelectorAll('.product__swatches').forEach(element => element.style.removeProperty('display'));
        this.querySelectorAll('button').forEach(button => {
          button.type = 'button';
          button.removeAttribute('ymq-add-to-cart-tags');
        });
        this.syncNativeLength();
      }

      handleClick(event) {
        const swatch = event.target.closest('.knilot-kp__item');
        if (swatch && this.contains(swatch)) {
          const group = swatch.closest('[data-kp-group]');
          const radio = swatch.querySelector('[data-kp-choice]');
          if (!group || !radio) return;
          if (event.target !== radio) event.preventDefault();
          event.stopImmediatePropagation();
          radio.checked = true;
          radio.focus({ preventScroll: true });
          this.syncGroup(group);
          return;
        }
        const button = event.target.closest('button');
        if (!button || !this.contains(button)) return;
        const group = button.closest('[data-kp-group]');
        if (!group) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (button.hasAttribute('data-kp-open')) this.openDialog(group);
        else if (button.hasAttribute('data-kp-close')) group.querySelector('[data-kp-dialog]').close();
        else if (button.hasAttribute('data-kp-apply')) {
          const radio = group.pendingChoice;
          if (!radio) return;
          radio.checked = true;
          radio.dispatchEvent(new Event('change', {bubbles:true}));
          group.querySelector('[data-kp-dialog]').close();
        }
        else if (button.hasAttribute('data-kp-scroll')) {
          const row = group.querySelector('[data-kp-row]');
          row.scrollBy({ left: Number(button.dataset.kpScroll) * Math.max(84, row.clientWidth - 84), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        } else if (button.hasAttribute('data-kp-dialog-choice')) {
          const radios = Array.from(group.querySelectorAll('[data-kp-choice]'));
          const radio = radios[Number(button.dataset.kpDialogChoice)];
          this.previewChoice(group, radio);
        }
      }

      openDialog(group) {
        const sage = this.form.querySelector('knilot-sage-personalizer');
        if (sage) { sage.open(true); return; }
        const christmas = this.form.querySelector('knilot-christmas-personalizer');
        if (christmas) { christmas.open(false); return; }
        const flatPouch = this.form.querySelector('knilot-flat-pouch-personalizer');
        if (flatPouch?.personalized) { flatPouch.open(false); return; }
        if (this.personalizerProduct) {
          this.form.dispatchEvent(new CustomEvent('knilot:open-personalizer', {
            bubbles: true,
            detail: { section: group.dataset.kpGroup }
          }));
          return;
        }
        const radios = Array.from(group.querySelectorAll('[data-kp-choice]'));
        const selected = radios.find(radio => radio.checked) || radios[0];
        this.previewChoice(group, selected);
        const dialog = group.querySelector('[data-kp-dialog]');
        if (!dialog.open) dialog.showModal();
        document.body.classList.add('knilot-kp-dialog-open');
        group.querySelector('[data-kp-open]').setAttribute('aria-expanded', 'true');
      }

      previewChoice(group, radio) {
        group.pendingChoice = radio;
        this.preview(group, radio);
        const radios = Array.from(group.querySelectorAll('[data-kp-choice]'));
        group.querySelectorAll('[data-kp-dialog-choice]').forEach((b,i) => b.setAttribute('aria-pressed',String(radios[i] === radio)));
        group.querySelector('[data-kp-dialog-selected]').textContent = radio.value;
        group.querySelector('[data-kp-apply]').textContent = this.dataset.useLabel.replace('__NAME__',radio.value);
      }

      preview(group, radio) {
        const name = group.querySelector('[data-kp-preview-name]');
        if (name) name.textContent = radio.value;
        const image = group.querySelector('[data-kp-large]');
        const solid = group.querySelector('[data-kp-large-solid]');
        if (image) {
          image.src = radio.dataset.image;
          image.alt = radio.dataset.previewAlt;
        }
        if (solid) {
          solid.style.setProperty('--knilot-kp-color', radio.dataset.color);
          solid.setAttribute('aria-label', radio.dataset.previewAlt);
        }
      }

      syncGroup(group) {
        const radios = Array.from(group.querySelectorAll('[data-kp-choice]'));
        const selected = radios.find(radio => radio.checked);
        if (selected) {
          group.querySelector('[data-kp-selected]').textContent = selected.value;
          group.querySelector('[data-kp-dialog-selected]').textContent = selected.value;
          group.querySelector('[data-kp-error]').hidden = true;
          this.querySelector('[data-kp-status]').textContent = this.dataset.selected + ' ' + selected.value;
          this.preview(group, selected);
          this.form.dispatchEvent(new CustomEvent('knilot:palette-change', {
            bubbles: true,
            detail: { palette: group.dataset.kpGroup, value: selected.value, color: selected.dataset.color, image: selected.dataset.image }
          }));
          const row = group.querySelector('[data-kp-row]');
          const item = selected.closest('.knilot-kp__item');
          const left = item.offsetLeft - row.offsetLeft;
          if (left < row.scrollLeft || left + item.offsetWidth > row.scrollLeft + row.clientWidth) row.scrollLeft = left;
        }
        group.querySelectorAll('[data-kp-dialog-choice]').forEach((button, index) => button.setAttribute('aria-pressed', String(radios[index].checked)));
        this.updateArrows(group);
        this.updatePaymentButton();
      }

      updateArrows(group) {
        const row = group.querySelector('[data-kp-row]');
        group.querySelector('[data-kp-scroll="-1"]').disabled = row.scrollLeft <= 4;
        group.querySelector('[data-kp-scroll="1"]').disabled = row.scrollLeft + row.clientWidth >= row.scrollWidth - 4;
      }

      updatePaymentButton() {
        const dynamic = this.form.querySelector('[data-dynamic-button]');
        const nativeButtons = Array.from(document.querySelectorAll('[data-buy-button="' + this.dataset.productId + '"]'));
        const available = this.lengthSelect ? this.lengthSelect.selectedOptions[0]?.dataset.available === 'true' : nativeButtons.some(button => !button.disabled);
        if (dynamic) dynamic.hidden = !available || !this.groups.every(group => group.querySelector('[data-kp-choice]:checked'));
      }

      requireGroup(group) {
        const error = group.querySelector('[data-kp-error]');
        error.textContent = this.dataset.required;
        error.hidden = false;
        this.openDialog(group);
      }

      canBuy() {
        if (!this.syncNativeLength()) {
          const error = this.querySelector('[data-kp-native-error]');
          if (error) error.hidden = false;
          return false;
        }
        const sage = this.form.querySelector('knilot-sage-personalizer');
        if (sage) return sage.validate();
        const flatPouch = this.form.querySelector('knilot-flat-pouch-personalizer');
        if (flatPouch?.personalized) return flatPouch.validate();
        const christmas = this.form.querySelector('knilot-christmas-personalizer');
        if (christmas) return christmas.validate();
        const incomplete = this.groups.find(group => !group.querySelector('[data-kp-choice]:checked'));
        if (incomplete) {
          this.requireGroup(incomplete);
          return false;
        }
        const invalidPersonalization = Array.from(this.form.querySelectorAll('[data-knilot-pf-control],[data-ep-font]')).find(control => !control.checkValidity());
        if (invalidPersonalization && this.personalizerProduct) {
          const section = invalidPersonalization.matches('[data-ep-font]') ? 'font' : 'name';
          this.form.dispatchEvent(new CustomEvent('knilot:open-personalizer', {
            bubbles: true,
            detail: { section, message: invalidPersonalization.validationMessage, focusId: invalidPersonalization.id }
          }));
          return false;
        }
        return this.form.reportValidity();
      }

      syncNativeLength() {
        if (!this.nativeLengths) return true;
        const variant = this.nativeLengths.find(item => String(item.id) === this.lengthSelect?.value);
        const input = this.form.querySelector('input[name="id"]');
        if (!variant || !variant.available || !input) return false;
        input.value = String(variant.id);
        this.querySelector('[data-kp-native-error]').hidden = true;
        return true;
      }

      updateNativeLength(updateUrl) {
        if (!this.lengthSelect) return;
        const option = this.lengthSelect.selectedOptions[0];
        if (!option) return;
        const input = this.form.querySelector('input[name="id"]');
        const price = this.querySelector('template[data-kp-price="' + option.value + '"]');
        if (!input || !price) return;
        input.value = option.value;
        input.defaultValue = option.value;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        this.querySelector('[data-kp-length-label]').textContent = option.textContent.trim();
        const holders = new Set();
        document.querySelectorAll('[data-product-price="' + this.dataset.productId + '"]').forEach(element => {
          const holder = element.closest('.product__price--holder');
          if (holder) holders.add(holder);
        });
        holders.forEach(holder => holder.replaceChildren(price.content.cloneNode(true)));
        const quantity = this.form.querySelector('[data-qty-input]');
        if (quantity) {
          if (option.dataset.max !== '') quantity.max = option.dataset.max;
          else quantity.removeAttribute('max');
        }
        document.querySelectorAll('[data-buy-button="' + this.dataset.productId + '"]').forEach(button => {
          button.disabled = option.dataset.available !== 'true';
          const text = button.querySelector('[data-button-text]');
          if (text) text.textContent = button.disabled ? this.dataset.soldOut : button.dataset.originalText;
        });
        if (option.dataset.available === 'true') this.querySelector('[data-kp-native-error]').hidden = true;
        this.updatePaymentButton();
        if (updateUrl) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', option.value);
          window.history.replaceState({}, '', url);
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["knilot-personalization-fields"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('knilot-personalization-fields')) {
    customElements.define('knilot-personalization-fields', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.form = this.closest('form[action*="/cart/add"]');
        if (!this.form) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.controls = Array.from(this.querySelectorAll('[data-knilot-pf-control]'));
        this.controls.forEach(control => control.addEventListener('input', () => {
          if (control.hasAttribute('data-knilot-pf-nonblank')) control.setCustomValidity(control.value.trim() ? '' : this.dataset.textRequired);
        }, { signal }));
        this.ymqBoxIds = Array.from(this.querySelectorAll('[data-ymq-box]')).map(element => element.dataset.ymqBox).filter(Boolean);
        this.form.addEventListener('submit', event => {
          if (!this.validate()) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        }, { signal, capture: true });
        document.addEventListener('click', event => {
          const target = event.target.closest('[data-buy-button="' + this.dataset.productId + '"]');
          if (target && !this.validate()) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        }, { signal, capture: true });
        this.removeYmq();
        this.ymqObserver = new MutationObserver(() => this.removeYmq());
        this.ymqObserver.observe(this.form, { childList: true, subtree: true });
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.ymqObserver?.disconnect();
      }

      removeYmq() {
        this.ymqBoxIds.forEach(id => {
          this.form.querySelectorAll('#' + CSS.escape(id)).forEach(element => element.remove());
        });
      }

      validate() {
        const invalid = this.controls.find(control => !control.checkValidity());
        if (!invalid) return true;
        if (this.form.querySelector('knilot-embroidery-preview')) {
          this.form.dispatchEvent(new CustomEvent('knilot:open-personalizer', {
            bubbles: true,
            detail: { section: 'name', message: invalid.validationMessage, focusId: invalid.id }
          }));
          return false;
        }
        invalid.reportValidity();
        return false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
